import { render, staticRenderFns } from "./RgAndK8sPanel.vue?vue&type=template&id=ffaac416&"
import script from "./RgAndK8sPanel.vue?vue&type=script&lang=js&"
export * from "./RgAndK8sPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports